<kv-editor-container [title]="title" menuTag="menuTag" [menuGroups]="menuGroups" [inputComponent]="inputComponent"></kv-editor-container>
